export enum FreightBookingActionTypes {
  SET_BOOKING_STATUS = "SET_BOOKING_STATUS",
  SET_FREIGHT_BOOKING_QUOTE = "SET_FREIGHT_BOOKING_QUOTE",
  FREIGHT_BOOKING_COMPLETED = "FREIGHT_BOOKING_COMPLETED",
  RESET_FREIGHT_BOOKING_STATE = "RESET_FREIGHT_BOOKING_STATE",
  PALLET_LABELS_DOWNLOAD_COMPLETED = "PALLET_LABELS_DOWNLOAD_COMPLETED",
  FREIGHT_ORDERS_GENERATED = "FREIGHT_ORDERS_GENERATED",
}
